import { render, staticRenderFns } from "./blocks_modal.vue?vue&type=template&id=fb757c7c&"
import script from "./blocks_modal.vue?vue&type=script&lang=ts&"
export * from "./blocks_modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports